// @ts-strict-ignore
import { useSelector } from 'react-redux'

import { categoriesItems } from 'store/selectors/selectors'

import { useUser } from '@/widgets/user'

import { TCartItem, useCart } from '@/entities/cart'
import { conditionAdapter } from '@/entities/Payments'

import { ProductType } from '@/shared/types/deprecated-types'

import { BasketItem } from '../basket-item/basket-item'

import cl from './basket-list.module.scss'

export type BasketListProps = {
	items: TCartItem[]
	additional?: boolean
}

export const BasketList = (): JSX.Element => {
	const categories = useSelector(categoriesItems)
	const { isJuridicalUser } = useUser()
	const { visibleProducts } = useCart()

	return (
		<ol className={cl.list} aria-label="Список товаров в вашей корзине">
			{visibleProducts?.map(item => (
				<BasketItem
					TYPE_PRODUCTS={ProductType.Accessory}
					categories={categories}
					{...item}
					count={item.QUANTITY}
					key={item.ID}
					isJuridicalUser={isJuridicalUser}
					conditionList={item.SPECIAL_CONDITIONS ? conditionAdapter(item.SPECIAL_CONDITIONS) : []}
				/>
			))}
		</ol>
	)
}
